const escapeHtml = require('stringify-entities').escape;

const allowedSwitchBy = [
  'text-tab',
  'text-tab-with-border',
  'image',
  'image-with-border',
  'chip',
  'chip-with-border',
  'table-content',
  'table-content-with-border',
  'select-box',
  'select-box-with-border',
  'pagination',
  'filter-image',
];

/** @param {import('markdown-it')} md */
module.exports = function tabSwitchText(md) {
  md.block.ruler.before('paragraph', 'switch_content', function replace(state, startLine, endLine, silent) {
    if (silent) {
      return false;
    }

    const expectOpenerRegExpStartString = '[switch-content';
    const expectOpenerRegExp = new RegExp(`^\\${expectOpenerRegExpStartString}-([^_\\s]+)_([^_\\s]+)(__([^\\s]+))?( default)?\\]`);

    const start = state.bMarks[startLine] + state.tShift[startLine];
    if (state.src.charAt(start) !== expectOpenerRegExpStartString[0]) {
      return false;
    }

    if (state.src.substr(start, expectOpenerRegExpStartString.length) !== expectOpenerRegExpStartString) {
      return false;
    }

    const result = expectOpenerRegExp.exec(state.src.substr(start));
    if (!result || result.length !== 6) {
      return false;
    }

    const opener = result[0];
    const switchBy = result[1];
    const group = result[2];
    const trigger = result[4] || '';
    const isDefault = opener.includes('default');
    const switchByToUnderscore = switchBy.replace('/-/g', '_');

    if (!allowedSwitchBy.includes(switchBy)) {
      return false;
    }

    const expectCloser = `${opener[0]}/${opener.substring(1)}`;

    let content = '';
    let closerLine;
    let closeFlag = false;

    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, expectCloser.length) === expectCloser) {
        closeFlag = true;
        break;
      }

      content += state.getLines(closerLine, closerLine + 1, state.blkIndent, false) + '\n';
    }

    if (!closeFlag) {
      return false;
    }

    const oldParent = state.parentType;
    let token;

    state.parentType = `switch_content_${switchByToUnderscore}`;
    token = state.push(`switch_content_${switchByToUnderscore}_open`, 'div', 1);
    token.markup = opener;
    token.attrs = [['class', `switch-content-${escapeHtml(switchBy)}${isDefault ? '' : ' disabled'}`], ['data-group', escapeHtml(group)]];
    if (trigger) {
      token.attrs.push(['data-trigger', escapeHtml(trigger)]);
    }
    token.block = true;

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);
    contentTokens.forEach((t) => {
      state.tokens.push(t);
    });

    token = state.push(`switch_content_${switchByToUnderscore}_close`, 'div', -1);
    token.markup = expectCloser;
    token.block = true;

    state.parentType = oldParent;
    state.line = closerLine + 1;

    return true;
  });
};
